/* eslint-disable */
import React from 'react';
import { Check } from '../../components/ui/check/Check';
import { Option } from '../../components/ui/check/Option';
import { useStore } from '../../store/store';
import { useNav } from '../../hooks/nav';
import Analytics from '@web-solutions/module-analytics';
import { t } from '@web-solutions/module-localization';
import { Title } from 'src/onboarding/components/typography/Title/Title';
import { Text } from 'src/onboarding/components/typography/Text/Text';
import { ReactComponent as BackIcon } from '../../assets/images/arrowLeft.svg';

function Page() {
  const fastingDetails = useStore((state) => state.fastingDetails);
  const setFastingDetails = useStore((state) => state.setFastingDetails);
  const { onNext, onPrev, currentIndex } = useNav();

  return (
    <div className={'page'}>
      {currentIndex !== 0 && (
        <div className={'back'} onClick={onPrev}>
          <BackIcon />
        </div>
      )}
      <div className={'wrapper-info'}>
        <Title tag='h2'>{t('onboarding.fastingDetails.title')}</Title>
        <Text className='description' size='m' medium>
          {t('onboarding.fastingDetails.subtitle')}
        </Text>
      </div>

      <div className={'controls'}>
        <Check
          defaultValue={fastingDetails}
          onChange={(value) => {
            setFastingDetails(value);
            Analytics.trackEvent(`step${currentIndex + 1}`, 'complete', {
              page: 'fasting-details',
              answer: value,
            });
            onNext();
          }}
        >
          <Option value={'twelveFourteen'}>
            <span>🕓</span> {t('onboarding.fastingDetails.options.twelveFourteen')}
          </Option>
          <Option value={'sixteenEighteen'}>
            <span>🕖</span> {t('onboarding.fastingDetails.options.sixteenEighteen')}
          </Option>
          <Option value={'twentyFourPlus'}>
            <span>📅</span> {t('onboarding.fastingDetails.options.twentyFourPlus')}
          </Option>
          <Option value={'notSure'}>
            <span>🤷</span> {t('onboarding.fastingDetails.options.notSure')}
          </Option>
        </Check>
      </div>
    </div>
  );
}
export default Page;
